import { combineReducers } from "@reduxjs/toolkit";
import entitiesReducer from "./entities";
import authentication from "./auth"

export default combineReducers({
    entities: entitiesReducer,
    auth: authentication
});
